module.exports = __webpack_public_path__ + "static/media/stop-circle.4a6442b8.svg";